import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { DatePipe, registerLocaleData} from '@angular/common';
import * as Sentry from '@sentry/angular';
import { provideKeyCloakAngular } from './keycloak.config';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { errorInterceptor } from './shared/interceptor/error-interceptor';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCALE_ID, useValue: 'de'},
    provideKeyCloakAngular(),
    DatePipe,
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([
      includeBearerTokenInterceptor,
      errorInterceptor])),
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true },
    provideZonelessChangeDetection(),
    provideRouter(appRoutes),
    provideServiceWorker('./ngsw-worker.js', {
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
};
